import flickityAsNavFor from "flickity-as-nav-for";
import FlickityClass from "common/utils/ui/flickity-class";
import initMastheadMenu from "components/masthead/redesign2025/component";
import { Redesign2025Masthead } from "components/masthead/redesign2025/redesign2025-masthead";

const initSlider = () =>
  new FlickityClass(
    ".js-masthead-redesign2025-slider",
    {
      selectedAttraction: 0.01,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      autoPlay: 5000,
      pauseAutoPlayOnHover: true
    },
    {
      library: flickityAsNavFor
    }
  ).initFlickity();

const initDropdown = () => {
  new Redesign2025Masthead({
    selector: ".js-account-dropdown-menu"
  }).init();
};
export default () => {
  initSlider();
  initDropdown();
  initMastheadMenu();
};
